import React from "react";
import { faAngleRight, faArrowLeft, faArrowRight, faBell, faBox, faDownload, faGift, faQuestionCircle, faReceipt, faSignOutAlt, faStopwatch, faTv, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./styles/UserProfile.scss";
import Img from "react-cool-img";
import {
  Badge, Card, CardTitle, CardGroup,
  CardFooter, CardHeader, CardBody, Button
} from "reactstrap";
import { Link } from "react-router-dom";

const UserProfile = (props) => {
  return (
    <section className="user-profile-container ">
      <div className="user-profile mt-3">
        <div className="w-100 d-flex justify-content-start align-items-center container-fluid">
          <FontAwesomeIcon icon={faArrowLeft} onClick={props.history.goBack} size="lg" className="back-button" />
        </div>
        <div className="user-profile-content">
          <div className="user-information container-fluid">
            <div className="user-name-avatar">
              <div className="img-container">
                <Img src="https://www.ipwatchdog.com/wp-content/uploads/2015/12/donald-trump-300.jpg" alt="user" />
                <p className="upload-image"><span>+</span></p>
              </div>
              <h2 className="username mt-2 mb-2">Donald Trump</h2>
              <Badge color="primary" pill tag="div" className="mb-3">Premium User</Badge>
            </div>
            <div className="subscription my-2">
              <p>Subscription Ending on</p>
              <p> | </p>
              <p>Janurary 31, 2020</p>
            </div>
          </div>
          <div className="action-container mt-4">
            <CardGroup>
              <Card className="bg-white">
                <Link to="/userprofile/:userId/subscription" className="w-100">
                  <CardBody>
                    <div className="first">
                      <CardTitle><FontAwesomeIcon icon={faTv} size="lg" className="card-icon g5-red" /></CardTitle>
                      <CardTitle className="card-name">Subscription Plans</CardTitle>
                    </div>
                    <div className="second">
                      <FontAwesomeIcon icon={faAngleRight} size="lg" className="text-dark visit-icon" />
                    </div>
                  </CardBody>
                </Link>
              </Card>
              <Card className="bg-white">
                <CardBody>
                  <div className="first">
                    <CardTitle><FontAwesomeIcon icon={faBell} size="lg" className="card-icon g5-blue" /></CardTitle>
                    <CardTitle className="card-name">Notification</CardTitle>
                  </div>
                  <div className="second">
                    <FontAwesomeIcon icon={faAngleRight} size="lg" className="text-dark visit-icon" />
                  </div>
                </CardBody>
              </Card>
              <Card className="bg-white">
                <CardBody>
                  <div className="first">
                    <CardTitle><FontAwesomeIcon icon={faStopwatch} size="lg" className="card-icon g5-orange" /></CardTitle>
                    <CardTitle className="card-name">My Watch List</CardTitle>
                  </div>
                  <div className="second">
                    <FontAwesomeIcon icon={faAngleRight} size="lg" className="text-dark visit-icon" />
                  </div>
                </CardBody>
              </Card>
              <Card className="bg-white">
                <CardBody>
                  <div className="first">
                    <CardTitle><FontAwesomeIcon icon={faUser} size="lg" className="card-icon g5-red" /></CardTitle>
                    <CardTitle className="card-name">Account</CardTitle>
                  </div>
                  <div className="second">
                    <FontAwesomeIcon icon={faAngleRight} size="lg" className="text-dark visit-icon" />
                  </div>
                </CardBody>
              </Card>
              <Card className="bg-white">
                <CardBody>
                  <div className="first">
                    <CardTitle><FontAwesomeIcon icon={faQuestionCircle} size="lg" className="card-icon g5-steelblue" /></CardTitle>
                    <CardTitle className="card-name">Subscription Plans</CardTitle>
                  </div>
                  <div className="second">
                    <FontAwesomeIcon icon={faAngleRight} size="lg" className="text-dark visit-icon" />
                  </div>
                </CardBody>
              </Card>
              <Card className="bg-white">
                <CardBody>
                  <div className="first">
                    <CardTitle><FontAwesomeIcon icon={faSignOutAlt} size="lg" className="card-icon g5-carolina" /></CardTitle>
                    <CardTitle className="card-name">Sign Out</CardTitle>
                  </div>
                  <div className="second">
                    <FontAwesomeIcon icon={faAngleRight} size="lg" className="text-dark visit-icon" />
                  </div>
                </CardBody>
              </Card>
            </CardGroup>
          </div>
        </div>
      </div>
      <style>{`
         ${!props.match.params.userId ? "" : "body .app-bar-container{display: none;}"}
      `}</style>
    </section>
  );
};

export default UserProfile;
